// extracted by mini-css-extract-plugin
export var divider = "_gc-7";
export var itemsToggle = "_gc-8";
export var mergeModal = "_gc-1";
export var optionCard = "_gc-4";
export var radioGroup = "_gc-6";
export var radioOption = "_gc-0";
export var selected = "_gc-5";
export var shipmentOptions = "_gc-2";
export var tableOptions = "_gc-3";